module.exports = __webpack_public_path__ + "static/media/pinterest.bd857f10.svg";